// extracted by mini-css-extract-plugin
module.exports = {"minilinks":"links_minilinks__1HJ-g","minilogo":"links_minilogo__aL1JZ"};